import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

const Pricing = () => {
  return (
    <div className="">
      <div className="container">
        <div className="p-4 mx-auto flex justify-center">
          <div  id="Pricing" className="section-heading">
            <h4>
              We Have The Best Pre-Order <em>Prices</em> You Can Get
            </h4>
            {/* <img src={headingLineDec} alt="" />
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eismod tempor incididunt ut labore et dolore magna.
          </p> */}
          </div>
        </div>
        <div className="flex flex-col sm:flex-row mx-auto width">
          <div className="w-full sm:w-1/2 p-4">
            <div className="pricing-item-regular">
              <span className="text-xl font-bold">$0</span>
              <h4 className="text-lg font-semibold">Free to trial</h4>
              {/* <div className="icon">
              <img src={pricingTable01} alt="" className="w-full h-auto mx-auto" />
            </div> */}
              <ul className="mt-4 text-justify ">
                <li className="flex gap-2"> <FontAwesomeIcon icon={faCheckCircle} className="text-blue-500 text-xl" /> <span ><strong>Pressing the summary button </strong>will switch to ChatGPT summary.</span></li>

                <li className="flex gap-2"> <FontAwesomeIcon icon={faTimesCircle} className="text-red-500 text-xl" /> <span>Support <strong>download pdf full course</strong></span></li>
                <li className="flex gap-2"> <FontAwesomeIcon icon={faTimesCircle} className="text-red-500 text-xl" /><span>Support <strong> summary all course</strong></span> </li>

                {/* <li className="non-function">Support summary all course</li> */}
                <li className="flex gap-2"> <FontAwesomeIcon icon={faTimesCircle} className="text-red-500 text-xl" /><span><strong>Automatically generate summaries </strong>directly within the Udemy interface (requires an API key - meaning users will incur costs based on OpenAI usage).</span></li>
              </ul>
              <div className="border-button mt-4">
                <a href="https://chromewebstore.google.com/detail/udemy-summary-harness-the/dcclmkicpmnakdmgehlbbcagfpkdpkdl" target="blank" className="border px-4 py-2 text-white bg-blue-500 rounded hover:bg-blue-600">Free to trial </a>
              </div>
            </div>
          </div>
          <div className="w-full sm:w-1/2 p-4">
            <div className="pricing-item-pro">
              <span className="text-xl font-bold">$4.99</span>
              <h4 className="text-lg font-semibold">Live Time</h4>
              {/* <div className="icon">
              <img src={pricingTable01} alt="" className="w-full h-auto mx-auto" />
            </div> */}
              <ul className="mt-4 text-justify">
                <li className="flex gap-2"> <FontAwesomeIcon icon={faCheckCircle} className="text-blue-500 text-xl" /> <span ><strong>Pressing the summary button </strong>will switch to ChatGPT summary.</span></li>

                <li className="flex gap-2"> <FontAwesomeIcon icon={faCheckCircle} className="text-blue-500 text-xl" /> <span>Support <strong>download pdf full course</strong></span></li>
                <li className="flex gap-2"> <FontAwesomeIcon icon={faCheckCircle} className="text-blue-500 text-xl" /><span>Support <strong> summary all course</strong></span> </li>

                {/* <li className="non-function">Support summary all course</li> */}
                <li className="flex gap-2"> <FontAwesomeIcon icon={faCheckCircle} className="text-blue-500 text-xl" /><span><strong>Automatically generate summaries </strong>directly within the Udemy interface (<strong>requires an API key </strong>- meaning users will incur costs based on OpenAI usage).</span></li>
              </ul>
              <div className="border-button mt-4">
                <a href="https://chromewebstore.google.com/detail/udemy-summary-harness-the/dcclmkicpmnakdmgehlbbcagfpkdpkdl" target="blank" className="border px-4 py-2 text-white bg-blue-500 rounded hover:bg-blue-600">Purchase This Plan Now</a>
              </div>
            </div>
          </div>
          {/* <div className="lg:w-1/3 px-7">
          <div className="pricing-item-regular">
            <span className="text-xl font-bold">$66</span>
            <h4 className="text-lg font-semibold">Premium Plan App</h4>
            <div className="icon">
              <img src="assets/images/pricing-table-01.png" alt="" className="w-full h-auto" />
            </div>
            <ul className="mt-4">
              <li>Lorem Ipsum Dolores</li>
              <li>120 TB of Storage</li>
              <li>Life-time Support</li>
              <li>Premium Add-Ons</li>
              <li>Fastest Network</li>
              <li>More Options</li>
            </ul>
            <div className="border-button mt-4">
              <a href="#" className="border px-4 py-2 text-white bg-blue-500 rounded hover:bg-blue-600">Purchase This Plan Now</a>
            </div>
          </div>
        </div> */}
        </div>

      </div>
    </div>
  );
};

export default Pricing;
